import { ExcelExport } from "@progress/kendo-react-excel-export";

export type ExportWorkbook = ReturnType<ExcelExport["workbookOptions"]>;

// Same ink as --rg-ink-alert in the grid's light theme (components/grecoreactgrid/styles.css).
export const EXPORT_ALERT_COLOR = "#a4262c";

export type RedColorFn = ((row: any) => boolean) | undefined;

// Marks in a Kendo workbook the cells a grid shows in red: `rows` must be parallel to the
// exported data rows and `redColorFns` parallel to the exported columns (undefined = never red),
// so the sheet and the grid agree by construction. Cells get the alert ink and bold text.
export const applyRedCellHighlights = (
  workbook: ExportWorkbook,
  rows: any[],
  redColorFns: RedColorFn[]
): ExportWorkbook => {
  const sheetRows = workbook.sheets?.[0]?.rows ?? [];
  // Kendo emits the caption row with type "header"; only data rows map to entries.
  const dataRows = sheetRows.filter((row) => row.type === "data");
  dataRows.forEach((sheetRow, rowIndex) => {
    const row = rows[rowIndex];
    if (!row || !sheetRow.cells) return;
    redColorFns.forEach((redColorFn, columnIndex) => {
      const cell = sheetRow.cells?.[columnIndex];
      if (!redColorFn || !cell || !redColorFn(row)) return;
      cell.color = EXPORT_ALERT_COLOR;
      cell.bold = true;
    });
  });
  return workbook;
};
